module.exports = "/call-frontend/img/icon-arrow-back.cbbf28c3.svg";